import React from 'react';

export const VerticalDialerDots = ({
  width = 7,
  height = 11,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 7 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1.27273C0 0.569819 0.56982 0 1.27273 0C1.97563 0 2.54545 0.569819 2.54545 1.27273C2.54545 1.97564 1.97563 2.54545 1.27273 2.54545C0.56982 2.54545 0 1.97564 0 1.27273Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 5.09091C0 4.388 0.569819 3.81818 1.27273 3.81818C1.97564 3.81818 2.54545 4.388 2.54545 5.09091C2.54545 5.79382 1.97564 6.36364 1.27273 6.36364C0.569819 6.36364 0 5.79382 0 5.09091Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8.90909C0 8.20618 0.569819 7.63636 1.27273 7.63636C1.97564 7.63636 2.54545 8.20618 2.54545 8.90909C2.54545 9.612 1.97564 10.1818 1.27273 10.1818C0.569819 10.1818 0 9.612 0 8.90909Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.81818 1.27273C3.81818 0.569819 4.388 0 5.09091 0C5.79382 0 6.36364 0.569819 6.36364 1.27273C6.36364 1.97564 5.79382 2.54545 5.09091 2.54545C4.388 2.54545 3.81818 1.97564 3.81818 1.27273Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.81818 5.09091C3.81818 4.388 4.388 3.81818 5.09091 3.81818C5.79382 3.81818 6.36364 4.388 6.36364 5.09091C6.36364 5.79382 5.79382 6.36364 5.09091 6.36364C4.388 6.36364 3.81818 5.79382 3.81818 5.09091Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.81818 8.90909C3.81818 8.20618 4.388 7.63636 5.09091 7.63636C5.79382 7.63636 6.36364 8.20618 6.36364 8.90909C6.36364 9.612 5.79382 10.1818 5.09091 10.1818C4.388 10.1818 3.81818 9.612 3.81818 8.90909Z"
      fill="currentColor"
    />
  </svg>
);
